<template>
  <section class="applications-section">
    <div class="container custom-container">
      
      <div class="text-content">
        <h2 class="section-title">
          <div class="title-top">
            Applications of <span class="red-line"></span>
          </div>
          <div class="title-bottom">Medical Parts</div>
        </h2>
        
        <p class="description">
       Our extensive production capabilities allow us to improve medical device production to serve many healthcare applications. Some of the applications include:
        </p>

        <ul class="app-list">
          <li v-for="(item, index) in applicationList" :key="index">
            <span class="check-icon">
             <svg viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="11" fill="#16bc9c" />
  <path d="M7 12.5L10.5 16L17 8" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
</svg>
            </span>
            <span class="list-text">{{ item }}</span>
          </li>
        </ul>
      </div>

      <div class="image-grid-container">
        <div class="image-grid">
          <div class="img-wrapper" v-for="(img, index) in images" :key="index">
            <img :src="img.src" :alt="img.alt" />
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';

// 左侧列表数据
const applicationList = ref([
  "Handheld devices",
  "Surgical instruments",
  "Medical testing devices",
  "Medical delivery systems",
  "Ventilators",
  "Implantable prototypes",
  "Prosthetic components",
  "Microfluidics",
  "UV sanitation components"
]);

// 右侧图片数据
const images = ref([
 { src: require('@/assets/product/Me/1.png'), alt: '' },
  { src: require('@/assets/product/Me/2.png'), alt: '' },
   { src: require('@/assets/product/Me/3.png'), alt: '' },
    { src: require('@/assets/product/Me/4.png'), alt: '' },
]);
</script>

<style scoped>
/* --- 全局容器 --- */
.applications-section {
  padding: 80px 20px;
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.custom-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start; /* 修改：改为顶部对齐，取消垂直居中 */
  gap: 60px;
}

/* ================== 左侧文本区域 ================== */
.text-content {
  flex: 1;
  padding-right: 20px;
}

/* 标题样式 */
.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #111111;
  margin: 0 0 24px 0;
  line-height: 1.3;
}

.title-top {
  display: flex;
  align-items: center;
  gap: 15px;
}

.red-line {
  display: inline-block;
  width: 50px;
  height: 4px;
  background-color: #0e957b; 

  transform: translateY(3px); 
}

/* 描述文本 */
.description {
  font-size: 16px;
  color: #444444;
  line-height: 1.6;
  margin: 0 0 30px 0;
}

/* 列表样式 */
.app-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.app-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.check-icon {
  flex-shrink: 0;
  margin-top: 3px; 
}

.list-text {
  font-size: 15px;
  color: #333333;
  line-height: 1.5;
}


/* ================== 右侧图片网格 ================== */
.image-grid-container {
  flex: 1;
  /* 新增：将右侧容器往下推。
     计算逻辑：标题 font-size(32px) * line-height(1.3) * 2行 = 约83px。
     加上 margin-bottom(24px)，总高度约 107px。 
  */
  margin-top: 107px; 

  /* 使用重复线性渐变实现斜纹背景 */
  background: repeating-linear-gradient(
    -45deg,
    #f2f2f2,
    #f2f2f2 15px,
    #fafafa 15px,
    #fafafa 30px
  );
  padding: 40px;
  min-width: 0; 
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.img-wrapper {
  background-color: #ffffff;
  width: 100%;
  aspect-ratio: 16 / 10; 
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); 
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover; 
  display: block;
}


/* ================== 响应式适配 ================== */
@media (max-width: 992px) {
  .custom-container {
    flex-direction: column;
    gap: 50px;
  }
  
  .text-content {
    padding-right: 0;
  }
  
  .image-grid-container {
    width: 100%;
    padding: 20px;
    margin-top: 0; /* 新增：移动端上下堆叠时，取消上边距，防止留白过大 */
  }
}

@media (max-width: 576px) {
  .image-grid {
    grid-template-columns: 1fr; 
  }
  
  .section-title {
    font-size: 26px;
  }
}
</style>